import { lazyNamed, loadable } from '../../../lazy';

export const SadFaceAnimationLazy = lazyNamed(
  () => import('./SadFaceAnimation'),
  'SadFaceAnimation'
);

export const SadFaceAnimation = loadable(SadFaceAnimationLazy, null);
